import BodyText from '../../atoms/BodyText';
import Icon from '../../atoms/Icon';
import classNames from 'classnames';
import * as styles from './alert.linaria';
function Alert({ className, children, icon = 'InfoCircle', layout, title, type = 'info', }) {
    return (<div className={classNames([
            'hj-alert',
            `hj-alert--${layout}`,
            `hj-alert--${type}`,
            !children && 'title-only',
            styles.style,
            className,
        ])} role={type === 'error' ? 'alert' : 'banner'}>
      <Icon icon={icon}/>
      <div className="hj-alert__content">
        {title && <BodyText className="hj-alert__title">{title}</BodyText>}
        <div className="hj-alert__children">{children}</div>
      </div>
    </div>);
}
Alert.defaultProps = {
    className: null,
    title: null,
    icon: 'InfoCircle',
    type: 'info',
    children: undefined,
};
export default Alert;
